import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import Text from 'components/Text';
import { Column, Row } from 'components/Layout/Grid';
import TabNavigation from 'components/TabNavigation';
import { dashboardClienteAction } from 'components/ApplicationInsights/eventNames';
import SelectNew from 'components/SelectNew';
import { MenuCompanies } from 'components/MenuCompanies';

import { CompaniesDocumentsProps } from './interface';
import DomainSettingService from 'services/domainSetting.service';

import './styles.scss';

const Police: React.FC = () => {
  const [allCompanies, setAllCompanies] = useState<CompaniesDocumentsProps[]>();
  const [showCompanies, setShowCompanies] = useState<boolean>(false);
  const [companySelected, setCompanySelected] = useState<string>('');

  const customer = useSelector((state: RootState) => state.customer);
  const user = useSelector((state: RootState) => state.user);
  const _domainSettingService = new DomainSettingService();

  const navigate = useNavigate();
  const userRoles = user?.roles?.[0] === 'administrator' && user?.userType === 'employee';

  useEffect(() => {
    if ((userRoles && !customer?.id) || Array.isArray(user?.selectedCustomerId))
      navigate('/dashboard');
  }, [user]);

  const getCompanies = async () => {
    const result = await _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: "CompaniesViveo" } },
          { enabled: { eq: true } },
        ],
      });

    const { value } = result.data[0];
    
    const jsonValue = JSON.parse(value);

    setAllCompanies(jsonValue);
    setCompanySelected(jsonValue[0]?.value || '');
  };

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <>
      <Text size={24} className="color-primary font-bold">
        Políticas de Negócio
      </Text>
      <Column className="mt-3">
        <TabNavigation
          trackingKey="Abas Políticas"
          tabLabels={[
            { label: 'Resumo', trackingName: dashboardClienteAction.ABA_POLITICA_RESUMO },
            { label: 'Politica de Troca e Devolução', trackingName: dashboardClienteAction.ABA_POLITICA_TROCA },
            { label: 'Documentos Legais Viveo', trackingName: dashboardClienteAction.ABA_DOCUMENTOS_REGULATORIOS }
          ]}
          pages={[
            <Column className="w-100 max-w-lg-100 flex-1 px-3 pb-3 bg-white mt-3 bg-radius-police">
              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  Objetivo
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Nosso compromisso é sua total satisfação nas compras realizadas no Grupo Viveo, sendo assim visando uma parceria de respeito e confiança, criamos a Política de Troca e Devolução, embasada no Código de Defesa do Consumidor, bem como na ética comercial que rege nossa conduta junto a clientes, fornecedores e colaboradores.
                </Text>
              </Row>
              <Row className="mt-3">
                <Column className="w-50 pr-2">
                  <Row>
                    <Text size={16} className="color-blue-gray font-bold">
                      Atenção as informações
                    </Text>
                  </Row>
                  <Row>
                    <Text size={14} className="color-blue-gray text-wrap">
                      Todas as solicitações de DEVOLUÇÃO devem ser realizadas diretamente no portal ou pelo Central de Negócios e ou representante Comercial do Grupo Viveo, no prazo de até 7 dias corridos da data de entrega, através das informações, contendo, motivo, produto, quantidade e número da Danfe Origem.
                    </Text>
                  </Row>
                  <Row className="mt-3">
                    <Text size={16} className="color-blue-gray font-bold">
                      Produto Cadeia Fria
                    </Text>
                  </Row>
                  <Row>
                    <Text size={14} className="color-blue-gray text-wrap">
                      Para produtos da cadeia fria a devolução só será aceita no ato da entrega, “antes que o volume seja aberto pelo cliente”.
                    </Text>
                  </Row>
                </Column>
                <Column className="w-50 pl-2">
                  <Row>
                    <Text size={16} className="color-blue-gray font-bold">
                      Notificação
                    </Text>
                  </Row>
                  <Row>
                    <Text size={14} className="color-blue-gray text-wrap">
                      Após a coleta, os produtos objeto da devolução, serão analisados pelo Departamento Controle de Qualidade (Farmácia) e constatada qualquer divergência entre produto e NF (lote, validade, produto, etc), indícios de manuseio indevido da mercadoria, (sujidade, etiquetas, rasuras, integridade da embalagem primaria, etc), o Grupo Viveo, ficará isenta de aceitar a sua solicitação e devolverá o produto ao seu endereço de entrega sem a correspondente restituição dos valores.
                    </Text>
                  </Row>
                </Column>
              </Row>
              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  Regulatório
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Todos os produtos comercializados pelo Grupo Viveo, estão em nosso processo de Boas Práticas da Qualidade que são exigidos pelos órgãos reguladores “ANVISA” e fornecedores, onde somos certificados periodicamente pelos mesmos.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Nosso controle de rastreabilidade de produtos, lote, validade e temperatura indicada por cada fabricante é diariamente inspecionado e assim assegurando a qualidade de nossos produtos até a entrega no cliente, onde não temos mais o controle dos produtos.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Todos os procedimentos “POPs” são certificados pela qualidade dos fornecedores para armazenagem, distribuição dos produtos, sendo feito periodicamente inspeções pelos mesmos em nossos processos e controles dos produtos, que nos valida o Certificado de Boas Práticas e caso tenhamos qualquer notificação, perdemos a licença para armazenamento e distribuição dos produtos.
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Sendo assim não temos como aceitar devolução fora do prazo da política de devolução e de produtos da “cadeia fria” após a entrega.
                </Text>
              </Row>
            </Column>,
            <Column className="w-100 max-w-lg-100 flex-1 px-3 pb-3 bg-white mt-3 bg-radius-police">
              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  1. Informações Gerais
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Nosso compromisso é sua total satisfação nas compras realizadas no Grupo Viveo, sendo assim, visando uma parceria de respeito e confiança, criamos a Política de Troca e Devolução, embasada no Código de Defesa do Consumidor, bem como na ética comercial que rege nossa conduta junto a clientes, fornecedores e colaboradores.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Com o intuito de prevenir eventuais problemas, solicitamos aos clientes que realizem os seguintes procedimentos ao receber a mercadoria adquirida.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  - Confira toda a mercadoria recebida impreterivelmente no ato da entrega.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Ao conferir a mercadoria, para evitar qualquer problema com a sua compra, fique atento com:
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  A) Descrição do produto;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  B) Especificações técnicas do produto;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  C) Quantidade;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  D) Preço ajustado / negociado;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  E) Prazos de pagamento;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  F) Validade;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  G) Formalidades Fiscais
                </Text>
              </Row>
              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  2. Atenção às informações abaixo
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Todas as solicitações de DEVOLUÇÃO devem ser realizadas diretamente no portal do Grupo Viveo ou a Central de Negócios e Representante Comercial do Grupo, no prazo de até 7 dias corridos após a entrega, caso seja pela central ou representante, uma declaração em papel timbrado contendo, motivo, produto, quantidade e número da Danfe, conforme Anexo “1”, via e-mail, onde a mesma será analisada conforme política.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Após análise e autorização por parte do Departamento Responsável será enviada a Ordem de Coleta (PD) para sequência no processo de coleta e Desconto no Boleto, condição esta que será ajustada obedecendo a vontade do cliente.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Após a coleta, os produtos objeto da devolução, serão analisados pelo Departamento Controle de Qualidade (Farmácia) e constatada qualquer divergência entre produto e NF (lote, validade, produto, etc), indícios de manuseio indevido da mercadoria, o Grupo Viveo, ficará isenta de aceitar a sua solicitação e devolverá o produto ao seu endereço de entrega sem a correspondente restituição dos valores pagos e as devidas cobrança do frete proveniente da devolução.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Caso constatado alguma das situações abaixo, favor seguir as
                  orientações descritas:
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  A) Produto avariado no transporte;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  B) Embalagem violada;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  C) Itens faltantes;
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  D) Produto em desacordo com o pedido
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Recuse o recebimento do produto e/ou entre em contato imediatamente com a Central de Negócios e ou Representante Comercial.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Caso haja a necessidade de recusa na entrega, declarar o motivo com carimbo e assinatura no verso da DANFE. Este procedimento poderá ser para devoluções totais ou parciais.
                </Text>
              </Row>
              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  3. Ocorrências para trocas e devoluções
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Existem diferentes tipos de ocorrências para trocas e
                  devoluções, sendo que, cada um possui um prazo máximo para que
                  seja registrada a Solicitação de Troca e Devolução no portal da
                  Viveo ou pela Central de Negócios ou Representante
                  Comercial.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  3.1. Produto em Desacordo com o Pedido: Prazo limite de até 7 (sete) dias corridos da data de recebimento do produto, de acordo com o artigo 49 do Código de Defesa do Consumidor, no momento do recebimento do produto adquirido, o cliente deverá realizar uma conferência sobre o pedido realizado, quantidades e todas as características da mercadoria. Caso o cliente receba um produto que não esteja de acordo com o pedido realizado no Grupo Viveo, proceder conforme descrito no item 2.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  3.2. Produto Danificado: No momento do recebimento do produto adquirido, o cliente deverá realizar uma conferência, para verificar se o produto se encontra avariado ou com indícios de manuseio indevido da mercadoria como: lacre rompido, amassado, molhado, etc, e no ato da entrega, proceder com a ressalva no verso da NF e devolver ao transportador.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  3.3. Desacordo pelo Cliente: Prazo limite de até 7 (sete) dias corridos da data de recebimento do produto. De acordo com o artigo 49 do Código de Defesa do Consumidor, caso o cliente desista ou se arrependa da compra de um produto, Grupo Viveo, aceita a devolução do mesmo, conforme item 2. O produto deverá ser devolvido integro, sem indícios de manuseio indevido, rompimento de lacre, rasuras na embalagem, etc, e toda despesa com frete retorno será cobrada do cliente.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  3.4. Produto com Defeito de Fabricação (Desvio de Qualidade):
                  Prazo de até 30 dias de acordo com o artigo 26 do Código de Defesa do Consumidor. O cliente deverá realizar o registro da Solicitação de Troca e Devolução, no portal Grupo Viveo, ou pela Central de Negócios e Representante Comercial, proceder conforme descrito no item 2. Após a coleta do produto o Grupo Viveo, realizará uma análise pelo Departamento Controle de Qualidade (Farmácia), para depois autorizar o crédito. Obs: Exceto Recall do Fornecedor que o prazo será estendido.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  3.5. Produto da Cadeia Fria (termolabeis): Para produtos da cadeia fria a devolução só será aceita no ato da entrega, “antes que o volume seja aberto pelo cliente”, fazer a ressalva no verso da NF do motivo da devolução. Instrução conforme boas práticas da qualidade. Anexo “2”.
                </Text>
              </Row>

              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  4. Considerações gerais
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Havendo devolução de produtos sem o registro no portal do Grupo Viveo, de Troca e Devolução e prévia autorização, fora do prazo citado acima, o Grupo Viveo, não se obriga a aceitar o mesmo. O cliente será comunicado e a mercadoria terá seu retorno ao endereço de coleta com a cobrança das despesas com frete.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Se ocorrer uma das situações acima, registre imediatamente sua solicitação no portal do Grupo Viveo ou na Central de Negócios ou Representante Comercial conforme descrito na Política de Troca e devolução no item 2.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Após o registro da Solicitação, a Central de Negócios e ou Representante Comercial, do Grupo Viveo, terá 02 (dois) dias úteis, a contar da data de solicitação para responder sua ocorrência. Temos uma equipe qualificada no Controle de Qualidade para análise e checagem das condições dos produtos enviados para devolução.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Os produtos farmacêuticos e medicamentos devolvidos para os nossos depósitos, que não apresentarem consistência de informações com a nota de origem pré-aprovada pelo portal Customer Care, deverão ser recusadas. O cliente será comunicado imediatamente e a mercadoria será devolvida e o frete será custeado pelo cliente.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Em situações em que a equipe de Controle de Qualidade diagnosticar a presença de indícios de manuseio indevido da mercadoria, o Grupo Viveo, isenta-se da obrigação de cancelar a compra, trocar ou consertar qualquer produto. O cliente será comunicado imediatamente e a mercadoria terá seu retorno ao endereço de coleta com a cobrança das despesas com frete.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Não serão aceitas Solicitações de Trocas ou Devoluções sem o atendimento aos procedimentos e regras descritas nesta Política de Troca e Devolução.
                </Text>
              </Row>

              <Row className="mt-3">
                <Text size={16} className="color-blue-gray font-bold">
                  5. Produto da Cadeia Fria (termolabeis)
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Todos os produtos da cadeia fria estão em nosso processo de boas práticas da qualidade que é exigido pelos órgãos reguladores “ANVISA” e fornecedores de produtos da cadeia fria.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Nosso controle de rastreabilidade de produto, lote, validade e temperatura indicada por cada fabricante é diariamente inspecionado e assim assegurando a qualidade de nossos produtos até a entrega no cliente, onde não temos mais controle do produto, sendo encerrada toda a rastreabilidade desde produto, NÃO podendo ser integrado novamente em nosso estoque.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Todos os procedimentos são certificados pela qualidade dos fornecedores para armazenagem, distribuição dos produtos desta linha, sendo feito periodicamente inspeções pelos mesmos em nosso processo e controle dos produtos, que nos valida o certificado de boas práticas e caso tenhamos qualquer notificação, perdemos a licença para armazenamento e distribuição do produto.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Sendo assim não temos como aceitar devolução de produtos da “cadeia fria”.
                </Text>
              </Row>

              <Row className="mt-3">
                <Text size={14} className="color-blue-gray font-bold">
                  CERTIFICAÇÕES E APROVAÇÕES
                </Text>
              </Row>
              <Row>
                <Text size={14} className="color-blue-gray text-wrap">
                  Nossos Centros de Distribuição (CDs) São licenciados pelos órgãos fiscalizadores competentes e certificados em Boas Práticas de Distribuição e Armazenamento pela ANVISA - Agência Nacional de Vigilância Sanitária e submetidos, periodicamente, à Visitação Técnica por parte do corpo técnico dos principais clientes. Além de obter aprovação do GAFO.
                </Text>
              </Row>
              <Row className="mt-2">
                <Text size={14} className="color-blue-gray text-wrap">
                  Também recebemos inspeções técnicas por parte dos principais fornecedores, obtendo constantes aprovações e feedbacks positivos para a distribuição de seus produtos.
                </Text>
              </Row>
            </Column>,
            <Column className="w-100 max-w-lg-100 flex-1 px-3 pb-3 bg-white mt-3 bg-radius-police">
              <Row className="mt-3">
                <Text size={14} className="color-blue-gray text-wrap">
                  A Viveo tem o compromisso com a satisfação total de nossos clientes, por isso preocupa-se com a garantia da qualidade em todos os seus processos logísticos. Focada em melhorias contínuas, possui vigente todos os documentos regulatórios exigidos para seu bom funcionamento. Selecione a empresa e conheça cada um deles abaixo.
                </Text>
              </Row>
              <Row className="mt-3">
                <SelectNew
                  key="company"
                  setSelected={setCompanySelected}
                  selected={companySelected}
                  allItems={allCompanies}
                  width={"160px"}
                  className="w-sm-100 w-md-100"
                  style={{ minWidth: 160 }}
                  show={showCompanies || false}
                  setShow={setShowCompanies}
                />
              </Row>
              <MenuCompanies allCompanies={allCompanies || []} companySelected={companySelected} />
            </Column>
          ]}
        />
      </Column>
    </>
  );
};

export default Police;
